<template>
  <div class="page-container" style="min-height: 0px; max-width: 630px;">
    <div class="thread-container">
      <span style="white-space: pre-wrap; font-size: 15px;">{{index}}/ {{unescapeHTML(text)}}</span>
      <div :key="`'url-${i}`" v-for="(url, i) in urls">
        <img class="image" v-if="url != null" :src="url">
      </div>
    </div>
    <div class="divider"></div>
  </div>
</template>

<script>
export default {
    props: ['text', 'index', "urls"],

    methods: {
      unescapeHTML(escapedHTML) {
        return escapedHTML.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&')
      }
    }
}
</script>

<style scoped>
.page-container{
  max-width: 1100px;
  min-height: 1100px;
  /* padding: 0 3rem; */
  margin: 0 auto;
}
.image{
  width: 100%;
  height: 100%;
  margin-top: 20px;
}
.thread-container{
  background-color: var(--secondary-text-color);
  padding: 1rem 1.5rem;
  padding-top: 0rem;
}
@media (max-width: 760px){
  .thread-container{
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  }
}
</style>